import { isMerchURI } from '@spotify-internal/uri';

import { OPTIONS_CLAIM_TYPE } from 'components/ContentReporting/ContentLegalReporting/content-legal-reporting-config';
import { CONTENT_TYPES } from 'components/ContentReporting/content-types';
import { isValidSpotifyUri } from 'components/ContentReporting/validation-utils';
import { ResolvedEntityType } from 'proto/generated/inspector_gadget';

import { MAXIMUM_NUMBER_URIS, MAXIMUM_NUMBER_URIS_NON_IP } from '../config/fields';
import { ASSOCIATED_CONTENT_ERRORS } from '../constants';

export const getUriMaxAmount = (claimType: any) => {
  if (OPTIONS_CLAIM_TYPE.OTHER === claimType) {
    return MAXIMUM_NUMBER_URIS_NON_IP;
  }

  return MAXIMUM_NUMBER_URIS;
};

export const areUrisValid =
  (acceptedTypes: CONTENT_TYPES[], maximumNumberOfURI: number) =>
  (uris: string[]): boolean => {
    const urisValidation = uris.map((uri: string) => isValidSpotifyUri(uri, acceptedTypes));

    return !urisValidation.includes(false) && uris.length <= maximumNumberOfURI;
  };

export const getURIErrorMessage = (resolvedEntityType: ResolvedEntityType, associatedContent?: any) => {
  if (!!resolvedEntityType && !resolvedEntityType.entityExists) {
    return isMerchURI(resolvedEntityType.uri)
      ? ASSOCIATED_CONTENT_ERRORS.NON_EXISTENT_MERCH_ASSOCIATED_CONTENT
      : ASSOCIATED_CONTENT_ERRORS.NON_EXISTENT_CONTENT;
  }

  if (!!associatedContent && !associatedContent.elements.length) {
    return ASSOCIATED_CONTENT_ERRORS.NON_EXISTENT_ASSOCIATED_CONTENT;
  }

  return undefined;
};
